// extracted by mini-css-extract-plugin
module.exports = {"container":"brands-module__container___xGPdx","title":"brands-module__title___D0eDl","brands":"brands-module__brands___Io5oB","brand":"brands-module__brand___4Al8n"};